// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-for-abstract[data-v-19628d04]{font-size:1rem}.payment-method[data-v-19628d04]{font-size:1.1rem;font-feature-settings:\"palt\"}.contracted-subscription__abstract .text-for-abstract[data-v-19628d04]{margin-top:10px}.contracted-subscription__footer .payment-method[data-v-19628d04]{margin-top:5px}", ""]);
// Exports
module.exports = exports;
